(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/handle-pay-response.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/handle-pay-response.js');

'use strict';

const statuses = {
  FAILURE: 'FAILURE',
  INCOMPLETE: 'INCOMPLETE',
  SUCCESS: 'SUCCESS'
};
function handlePayResponse(_ref) {
  let next = _ref.next,
    cancel = _ref.cancel,
    onError = _ref.onError,
    regWagerResults = _ref.regWagerResults,
    wagers = _ref.wagers,
    apiWagers = _ref.apiWagers,
    _ref$successfulWagers = _ref.successfulWagers,
    successfulWagers = _ref$successfulWagers === void 0 ? [] : _ref$successfulWagers,
    _ref$failedWagers = _ref.failedWagers,
    failedWagers = _ref$failedWagers === void 0 ? [] : _ref$failedWagers;
  const incompleteWagers = [];
  for (let i = 0, len = regWagerResults.length; i < len; i++) {
    const _regWagerResults$i = regWagerResults[i],
      status = _regWagerResults$i.status,
      regWagerResult = _regWagerResults$i.regWagerResult,
      tpError = _regWagerResults$i.tpError;
    const wager = wagers[wagers.length - (regWagerResults.length - i)];
    if (status === statuses.FAILURE) {
      failedWagers.push({
        tpError,
        wager
      });
    }
    if (status === statuses.INCOMPLETE) {
      incompleteWagers.push(apiWagers[i]);
    }
    if (status === statuses.SUCCESS) {
      successfulWagers.push({
        wagerClientSerial: regWagerResult.wagerClientSerial,
        wagerAmounts: regWagerResult.wagerAmounts,
        wager
      });
    }
  }
  if (!successfulWagers.length && !incompleteWagers.length) {
    var _failedWagers$;
    const error = {
      code: (_failedWagers$ = failedWagers[0]) === null || _failedWagers$ === void 0 || (_failedWagers$ = _failedWagers$.tpError) === null || _failedWagers$ === void 0 ? void 0 : _failedWagers$.errCode
    };
    svs.tur.pay_lyckoplatsen.apiErrors(error);
    cancel();
    onError === null || onError === void 0 || onError(error);
    return;
  }
  next({
    successfulWagers,
    incompleteWagers,
    failedWagers
  });
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  handlePayResponse
});

 })(window);